export default {
  namespaced: true,
  state: {
    withdraw_commission: {},
    deposit_commission: {},
    penalty: [],
  },
  mutations: {
    resetState(state) {
      state.withdraw_commission = {};
      state.deposit_commission = {};
      state.penalty = {};
    },
      getWithdrawCommission(state, data) {
          state.withdraw_commission = data;
      },
      getDepositCommission(state, data) {
          state.deposit_commission = data;
      },
      updateDepositCommission(state, data) {
          state.deposit_commission = data;
      },
      updateWithdrawCommission(state, data) {
          state.withdraw_commission = data;
      },
      getPenalty(state, data) {
          state.penalty = data;
      },
      updatePenalty(state, data) {
          state.penalty = data;
      },
  },
  actions: {  
    async getWithdrawCommission({ commit, dispatch }) {
      let url = `backoffice/getWithdrawalCommission`;
      try {
        let res = await dispatch("fetchGeneral/axiosPathGetData", url, {
          root: true
        });
  
        if (typeof res.msg == "boolean" && res.msg == false) {
          return false;
        } else {
          commit("getWithdrawCommission", res.data);
          return res.data;
        }
      } catch (error) {
        let error_res = {"wd_credit_commission_type":1,"wd_credit_commission_amount":0.0,"wd_credit_commission_max":0.0,"wd_coin_commission_type":1,"wd_coin_commission_amount":0.0,"wd_coin_commission_max":0.0};
        commit("getWithdrawCommission", error_res);
        return "error";
      }
     
      },
    async getDepositCommission({ commit, dispatch }) {
      let url = `backoffice/getTopupCommission`;
      try {
        let res = await dispatch("fetchGeneral/axiosPathGetData", url, {
          root: true
        });
      
        if (typeof res.msg == "boolean" && res.msg == false) {
          return false;
        } else {
          commit("getDepositCommission", res.data);
          return res.data;
        }
      } catch (error) {
        let error_res ={"dp_credit_commission_type":1,"dp_credit_commission_amount":0.0,"dp_credit_commission_max":0.0,"dp_coin_commission_type":1,"dp_coin_commission_amount":0.0,"dp_coin_commission_max":0.0};
        commit("getDepositCommission", error_res);
        return "error";
      }
     
      },
    async updateWithdrawCommission({ commit, dispatch },payload) {
        let url = "/backoffice/updateWithdrawalCommission";
        let res = await dispatch("fetchGeneral/axiosPathPutData", { url, form: payload.body }, {
            root: true
        });
        if (typeof res.msg == "boolean" && res.msg == false) {
            return false;
        } else {
            commit("updateWithdrawCommission", payload.data_save);
            return true;
        }
    },
    async updateDepositCommission({ commit, dispatch }, payload) {
        let url = "/backoffice/updateTopupCommission";
        let res = await dispatch("fetchGeneral/axiosPathPutData", { url, form: payload.body }, {
            root: true
        });
        if (typeof res.msg == "boolean" && res.msg == false) {
            return false;
        } else {
            commit("updateDepositCommission", payload.data_save);
            return true;
        }
    },
    async getPenalty({ commit, dispatch }) {
      let url = `/Office/getPenalty`
      try {
        let res = await dispatch("fetchGeneral/axiosPathGetData", url, {
          root: true
        });
          console.log(url);
        if (typeof res.msg == "boolean" && res.msg == false) {
          return false;
        } else {
          commit("getPenalty", res.data);
          return res.data;
        }
      } catch (error) {
        commit("getPenalty", []);
        return false;
      }
     
    },
    async updatePenalty({ commit, dispatch }, payload) {
        let url = "/Office/updatePenalty";
        let res = await dispatch("fetchGeneral/axiosPathPutData", { url, form: payload.body }, {
            root: true
        });
        if (typeof res.msg == "boolean" && res.msg == false) {
            return false;
        } else {
            commit("updatePenalty", payload.data_save);
            return true;
        }
    },
  }
};
